import { sanitiseHtml } from "src/core/utilities/sanitiseHtml";

interface Props {
    html: string;
    className?: string;
}

// The only place authored rich text should reach the DOM
export const SanitisedHtml = ({ html, className }: Props) => (
    <div className={className} dangerouslySetInnerHTML={{ __html: sanitiseHtml(html) }} />
);
